<ng-container *abcLet="res$ | async as res">
  <div class="containerOperatingHours resource_event_border">
    <div class="detailContainerOperatingHours">
      <div fxLayout="row" class="icon-container">
        <mat-icon
          class="iconHeaderOperatingHours"
          [svgIcon]="res.svgName(this.resourcesNavigationContext.resourceEventGroup.resourceEventTypeGroup.iconName)"
        ></mat-icon>
        <span class="resource_event_boldLabel">{{
          this.resourcesNavigationContext.resourceEventGroup.resource.name
        }}</span>
      </div>
      <resource-navigation></resource-navigation>
      <div fxLayout="row" fxLayout.xs="column" fxLayoutWrap fxLayoutGap="16px" class="startContainer">
        <div class="dateHolder">
          <abc-date-box
            (onValueChanged)="safeSetValue($event, 'date')"
            [disabled]="this.isDisabled"
            [labelMode]="'floating'"
            [label]="res.get('Resources-ResourceEvent-StartDate')"
            [showClearButton]="true"
            [stylingMode]="'filled'"
            [type]="'date'"
            [useMaskBehavior]="true"
            [value]="this.resourceEvent?.date"
            [ngStyle]="{ width: '230px' }"
            [ngStyle.xs]="{ width: '380px' }"
            valueChangeEvent="keyup"
          >
          </abc-date-box>
        </div>
        <div class="timeHolder">
          <abc-date-box
            (onValueChanged)="safeSetValue($event, 'time')"
            [disabled]="this.isDisabled"
            [labelMode]="'floating'"
            [label]="res.get('Resources-ResourceEvent-StartTime')"
            [showClearButton]="true"
            [stylingMode]="'filled'"
            [type]="'time'"
            [useMaskBehavior]="true"
            [value]="this.resourceEvent?.time"
            [ngStyle]="{ width: '230px' }"
            [ngStyle.xs]="{ width: '380px' }"
            valueChangeEvent="keyup"
          >
          </abc-date-box>
        </div>
        <div class="pauseHolder">
          <abc-number-box
            (onValueChanged)="safeSetValue($event, 'value')"
            [disabled]="this.isDisabled"
            [labelMode]="'floating'"
            [label]="res.get('Resources-ResourceEvent-StartValue')"
            [showClearButton]="true"
            [stylingMode]="'filled'"
            [value]="this.resourceEvent?.value"
            [ngStyle]="{ width: '160px' }"
            [ngStyle.xs]="{ width: '380px' }"
            [format]="this.resourceEvent?.valueFormat"
            valueChangeEvent="keyup"
          >
          </abc-number-box>
        </div>
      </div>
      <div fxLayout="row" fxLayout.xs="column" fxLayoutWrap fxLayoutGap="16px" class="endContainer">
        <div class="dateHolder">
          <abc-date-box
            (onValueChanged)="safeSetValue($event, 'endDate')"
            [disabled]="this.isDisabled"
            [labelMode]="'floating'"
            [label]="res.get('Resources-ResourceEvent-EndDate')"
            [showClearButton]="true"
            [stylingMode]="'filled'"
            [type]="'date'"
            [value]="this.resourceEvent?.endDate"
            [ngStyle]="{ width: '230px' }"
            [ngStyle.xs]="{ width: '380px' }"
            valueChangeEvent="keyup"
          >
          </abc-date-box>
        </div>
        <div class="timeHolder">
          <abc-date-box
            (onValueChanged)="safeSetValue($event, 'endTime')"
            [disabled]="this.isDisabled"
            [labelMode]="'floating'"
            [label]="res.get('Resources-ResourceEvent-EndTime')"
            [showClearButton]="true"
            [stylingMode]="'filled'"
            [type]="'time'"
            [useMaskBehavior]="true"
            [value]="this.resourceEvent?.endTime"
            [ngStyle]="{ width: '230px' }"
            [ngStyle.xs]="{ width: '380px' }"
            valueChangeEvent="keyup"
          >
          </abc-date-box>
        </div>
        <div class="pauseHolder">
          <abc-number-box
            (onValueChanged)="safeSetValue($event, 'endValue')"
            [disabled]="this.isDisabled"
            [labelMode]="'floating'"
            [label]="res.get('Resources-ResourceEvent-EndValue')"
            [showClearButton]="true"
            [stylingMode]="'filled'"
            [value]="this.resourceEvent?.endValue"
            [ngStyle]="{ width: '160px' }"
            [ngStyle.xs]="{ width: '380px' }"
            [format]="this.resourceEvent?.valueFormat"
            valueChangeEvent="keyup"
          >
          </abc-number-box>
        </div>
      </div>
      <div fxLayout="row" fxLayout.xs="column" fxLayoutWrap fxLayoutGap="16px" class="endContainer">
        <div class="dateHolder">
          <abc-drop-down-box
            #resourceEventType
            (onValueChanged)="safeSetValue($event, 'idRefResourceEventType')"
            [disabled]="this.isDisabled"
            [labelMode]="'floating'"
            [label]="res.get('Resources-ResourceEvent-Type')"
            [stylingMode]="'filled'"
            [validationStatus]="'valid'"
            [value]="this.resourceEvent?.idRefResourceEventType"
            [ngStyle]="{ width: '230px' }"
            [ngStyle.xs]="{ width: '380px' }"
          ></abc-drop-down-box>
        </div>
        <div class="pauseHolder">
          <abc-number-box
            (onValueChanged)="safeSetValue($event, 'timespanOffAsHours')"
            [disabled]="this.isDisabled"
            [labelMode]="'floating'"
            [label]="res.get('Resources-ResourceEventOperatingHours-PauseDuration')"
            [showClearButton]="true"
            [stylingMode]="'filled'"
            [value]="this.resourceEvent?.timespanOffAsHours"
            [ngStyle]="{ width: '230px' }"
            [ngStyle.xs]="{ width: '380px' }"
            [format]="ResourcesConstants.TimespanOffFormatString"
            valueChangeEvent="keyup"
          >
          </abc-number-box>
        </div>
        <div class="hoursHolder">
          <abc-number-box
            (onValueChanged)="safeSetValue($event, 'resultValue')"
            [disabled]="this.isDisabled"
            [labelMode]="'floating'"
            [label]="res.get('Resources-ResourceEvent-Value')"
            [showClearButton]="true"
            [stylingMode]="'filled'"
            [value]="this.resourceEvent?.resultValue"
            [ngStyle]="{ width: '160px' }"
            [ngStyle.xs]="{ width: '380px' }"
            [format]="this.resourceEvent?.valueFormat"
            valueChangeEvent="keyup"
          >
          </abc-number-box>
        </div>
      </div>
      <div fxLayout="row" fxLayout.xs="column">
        <div>
          <abc-text-area
            (onValueChanged)="safeSetValue($event, 'comment')"
            [disabled]="this.isDisabled"
            [height]="'90px'"
            [labelMode]="'floating'"
            [label]="res.get('Resources-ResourceEventOperatingHours-Description')"
            [stylingMode]="'filled'"
            [value]="this.resourceEvent?.comment"
            [ngStyle]="{ width: '652px' }"
            [ngStyle.xs]="{ width: '380px' }"
            valueChangeEvent="keyup"
          >
          </abc-text-area>
        </div>
      </div>
    </div>
  </div>
</ng-container>
